/* KÔBO — micro-interactions : curseur grain de café, ajout au panier animé,
   transitions entre pages. Tout est conditionné à la capacité de la machine et
   au réglage « animations réduites » : rien ici n'est imposé. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var root = document.documentElement;

  /* ============ 1. Curseur grain de café (desktop, souris uniquement) ============ */
  if (fine && !reduce && window.innerWidth >= 1000) {
    var dot = document.createElement('div');
    dot.className = 'k-cur';
    dot.setAttribute('aria-hidden', 'true');
    dot.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22">' +
      '<ellipse cx="12" cy="12" rx="6.4" ry="9.6" transform="rotate(-28 12 12)" fill="#e8e6e2"/>' +
      '<path d="M12 3.4c-2.6 3.2-2.6 14 0 17.2" stroke="#000" stroke-width="1.5" fill="none" stroke-linecap="round" transform="rotate(-28 12 12)"/>' +
      '</svg>';
    document.body.appendChild(dot);
    root.classList.add('k-has-cur');

    var x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y, spin = 0, alive = true;
    addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      var t = e.target;
      var over = t && t.closest && t.closest('a,button,input[type=range],[role=button],label.k-rng,summary');
      dot.classList.toggle('is-on', !!over);
    }, { passive: true });
    addEventListener('pointerdown', function () { dot.classList.add('is-down'); }, { passive: true });
    addEventListener('pointerup', function () { dot.classList.remove('is-down'); }, { passive: true });
    document.addEventListener('mouseleave', function () { dot.classList.add('is-out'); });
    document.addEventListener('mouseenter', function () { dot.classList.remove('is-out'); });
    document.addEventListener('visibilitychange', function () { alive = !document.hidden; if (alive) loop(); });

    function loop() {
      if (!alive) return;
      cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
      spin += (x - cx) * 0.12;
      dot.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0) translate(-50%,-50%) rotate(' + spin.toFixed(1) + 'deg)';
      requestAnimationFrame(loop);
    }
    loop();
  }

  /* ============ 2. Ajout au panier animé ============ */
  /* On note le dernier bouton cliqué pour savoir d'où partir, puis on enveloppe
     koboCart.add sans la modifier : si l'animation échoue, l'ajout se fait quand même. */
  var lastBtn = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-k-add],[data-add],button[type=submit],.k-buyrow .k-btn,.k-qadd');
    if (b) lastBtn = b;
  }, true);

  function flyToCart(from) {
    if (reduce || !from) return;
    var cart = document.querySelector('.k-cart');
    if (!cart) return;
    var card = from.closest('.k-card,.k-pdp,.k-marq-item,article') || document;
    var img = card.querySelector && card.querySelector('img');
    var a = (img || from).getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width) return;

    var fly = document.createElement('div');
    fly.className = 'k-fly';
    fly.setAttribute('aria-hidden', 'true');
    if (img) { var c = img.cloneNode(); c.removeAttribute('loading'); fly.appendChild(c); }
    fly.style.cssText += ';left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
    document.body.appendChild(fly);

    requestAnimationFrame(function () {
      fly.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' +
        (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.08) rotate(14deg)';
      fly.style.opacity = '0';
    });
    setTimeout(function () { fly.remove(); }, 820);
    cart.classList.remove('k-cart-pop');
    void cart.offsetWidth;
    cart.classList.add('k-cart-pop');
  }

  function hookCart() {
    if (!window.koboCart || window.koboCart.__kobofx) return false;
    var orig = window.koboCart.add;
    window.koboCart.add = function () {
      var btn = lastBtn;
      return orig.apply(this, arguments).then(function (j) {
        try { flyToCart(btn); } catch (e) {}
        return j;
      });
    };
    window.koboCart.__kobofx = true;
    return true;
  }
  if (!hookCart()) {
    var tries = 0, iv = setInterval(function () { if (hookCart() || ++tries > 40) clearInterval(iv); }, 150);
  }

  /* ============ 3. Transition entre les pages ============ */
  if (!reduce) {
    root.classList.add('k-pt');
    requestAnimationFrame(function () { root.classList.add('k-pt-in'); });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.dataset.noTransition != null) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search) return;

      e.preventDefault();
      root.classList.remove('k-pt-in');
      /* Filet de sécurité : si la navigation traîne, on ne laisse pas l'écran voilé. */
      var go = setTimeout(function () { location.href = a.href; }, 260);
      addEventListener('pagehide', function () { clearTimeout(go); }, { once: true });
    });

    /* Retour arrière depuis le cache du navigateur : la page revient voilée sinon. */
    addEventListener('pageshow', function (e) { if (e.persisted) root.classList.add('k-pt-in'); });
  }
})();

/* Bannière cookies : « Déclin » est une traduction automatique ratée de
   « Decline » renvoyée par le serveur de Pandectes. Le texte n'est pas un
   réglage Shopify, il n'est donc pas atteignable autrement que sur le rendu.
   Correction volontairement étroite : on ne touche QUE ce mot exact, et
   uniquement à l'intérieur de la bannière. Le vrai correctif est dans l'app —
   dès qu'il y sera fait, ce bloc deviendra sans effet de lui-même. */
(function () {
  var FIX = { 'Déclin': 'Refuser', 'Décliner': 'Refuser' };
  function pass(root) {
    var els = (root || document).querySelectorAll(
      '[id*="pandectes" i] button, [class*="pandectes" i] button, [id*="cookie" i] button, [class*="cookie" i] button, [id*="consent" i] button, [class*="consent" i] button'
    );
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').trim();
      if (FIX[t]) els[i].textContent = FIX[t];
    }
  }
  pass();
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) if (recs[i].addedNodes.length) { pass(); return; }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    /* La bannière est injectée une seule fois : on arrête d'observer après 15 s. */
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
